import styled from "styled-components";

export const PrintMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.dataViz.printMessageTitleColor};
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const Content = styled.div`
  color: ${({ theme }) => theme.colors.dataViz.printMessageColor};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
